export default __webpack_public_path__ + "static/media/handshake-active.080f63b4.svg";